import { waveAdvanceCommands, waveProgress } from "../lib/artifactWaveProgress.js";

export default function ArtifactWaveProgress({ row }) {
    if (["ARTIFACT_PUBLICATION_STATE_PENDING", "ARTIFACT_PUBLICATION_STATE_DECLINED"].includes(row.publicationState)) return <div>Not started</div>;
    if (row.audienceKind === "ARTIFACT_AUDIENCE_KIND_TENANT_PREVIEW") return <div>All preview endpoints together</div>;
    const progress = waveProgress(row);
    if (progress.complete) return null;
    if (!progress.known) return <div className="text-[9px] text-[color:var(--muted-soft)]">Wave progress unavailable. Refresh before advancing.</div>;
    return <div className="mt-1 text-[10px] font-medium text-[color:var(--ink)]">Wave {progress.currentWave} of {progress.finalWave} open</div>;
}

export function AdvanceArtifactWaveButton({ buttonClass, disabled, onRun, row }) {
    const commands = waveAdvanceCommands(row);
    const progress = waveProgress(row);
    if (progress.complete) return null;
    const text = progress.known
        ? progress.currentWave === progress.finalWave ? "Complete final wave" : `Advance to wave ${progress.currentWave + 1}`
        : "Advance wave";
    return <button type="button" className={buttonClass} disabled={disabled || !commands.length}
        title={disabled ? "Refresh to load current wave progress before advancing." : "Advance this release from its current wave."}
        onClick={() => void onRun("advanceWave", commands)}>{text}</button>;
}
